import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, computed, observable, runInAction} from 'mobx';
import type {HelpType} from '../data';
import {HelpApi} from '../data';

class IntroductionController {
    @observable accessor page: 'intro' | 'gameplay' | 'cheatsheet';
    @observable accessor texts!: HelpType;

    @observable accessor loaded: boolean;

    constructor(
        private helpApi: HelpApi
    ) {
        this.page = 'intro';

        this.loaded = false;
    }

    @action load = async () => {
        const texts = await this.helpApi.get();

        runInAction(() => {
            this.texts = texts;
            this.loaded = true;
        });
    };

    hasNext = () => {
        return this.page !== 'cheatsheet';
    }

    hasPrevious = () => {
        return this.page !== 'intro';
    }

    @computed get currentText() {
        if (this.page === 'intro') {
            return this.texts.intro;
        }
        else if (this.page === 'gameplay') {
            return this.texts.gameplay;
        }
        else {
            return this.texts.cheatsheet;
        }
    }

    @action setNext = () => {
        if (this.page === 'intro') {
            this.page = 'gameplay';
        } else if (this.page === 'gameplay') {
            this.page = 'cheatsheet';
        }
    }

    @action setPrevious = () => {
        if (this.page === 'cheatsheet') {
            this.page = 'gameplay';
        } else if (this.page === 'gameplay') {
            this.page = 'intro';
        }
    }
}

decorate(injectable(), IntroductionController);
decorate(inject(HelpApi), IntroductionController, 0);

export {IntroductionController};
